// extracted by mini-css-extract-plugin
module.exports = {"chip--container":"chip--container__3f1TT","icon--style":"icon--style__EnTmG","chip--label":"chip--label__3l8Qm"};